export const { REACT_APP_FRONT_URL, REACT_APP_API_URL, REACT_APP_LOCAL_URL, REACT_LOCAL_API_URL, DEEPGRAM_API_KEY } = process.env